import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest} from '../generalRequest';

const initialState = {
    shouldDisplayInvoiceList: false,
    shouldDisplaySingleInvoice: false,
    shouldDisplayMainUtilityView: true,
    isTransactionSuccessfullyStarted : false,
    isTransactionSuccessfullyCompleted: false,
    isOfferTransactionSuccessfullyStarted: false,
    isOfferTransactionSuccessfullyCompleted: false,
    selectedOffer: '', 
    isConfirmationDialogOpen: false,
    phone: '',
    transactionId: '',
    localCode: '',
    invoiceList: [],
    singleInvoice: {},
    isLoading: false
};

export const albtelecomMobileSlice = createSlice({
    name: 'albtelecomMobile',
    initialState,
    reducers:{
        displayInvoiceList : (state) => {
            state.shouldDisplayInvoiceList = true
            state.shouldDisplaySingleInvoice = false
            state.shouldDisplayMainUtilityView = false
        },
        displaySingleInvoice : (state) => {
            state.shouldDisplaySingleInvoice = true
            state.shouldDisplayInvoiceList = false
            state.shouldDisplayMainUtilityView = false
        },
        displayMainUtilityView : (state) => 
        {
            state.shouldDisplaySingleInvoice = false
            state.shouldDisplayInvoiceList = false
            state.shouldDisplayMainUtilityView = true
        },
        changeConfirmationDialogState: (state) =>
        {
            state.isConfirmationDialogOpen = !state.isConfirmationDialogOpen
        },
        setPhone: (state, action) => 
        {
            state.phone = action.payload
        },
        setSelectedOffer: (state, action) => 
        {
            state.selectedOffer = action.payload
        },
        setIsTransactionSuccessfullyStarted: (state, action) => 
        {
            state.isTransactionSuccessfullyStarted = action.payload
        },
        setIsTransactionSuccessfullyCompleted: (state, action) => 
        {
            state.isTransactionSuccessfullyCompleted = action.payload
        },
        resetAlbTelecomMobileSlice : () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            }) 
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.endpoint === 'Eagle/StartTransaction')
                {         
                    state.transactionId = action.payload.response.transID
                    state.isTransactionSuccessfullyStarted = true
                }
                else if(action.payload.endpoint === 'Eagle/ConfirmTransaction')
                {         
                    state.isTransactionSuccessfullyStarted = false
                    state.isTransactionSuccessfullyCompleted = true  
                }
                else if(action.payload.endpoint === 'Eagle/GetEagleOffers')
                {        
                    state.invoiceList = action.payload.response.offers.map(offer => { return { Emri: offer.OfferName, Pershkrimi: offer.OfferDescription, Vlera: offer.OfferPrice + ' Leke', Id: offer.OfferId}})
                    state.shouldDisplayInvoiceList = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayMainUtilityView = false          
                }
                else if(action.payload.endpoint === 'Eagle/StartOfferEagle')
                {         
                    state.transactionId = action.payload.response.transID
                    state.isOfferTransactionSuccessfullyStarted = true
                }
                else if(action.payload.endpoint === 'Eagle/ConfirmOfferEagle')
                {         
                    state.isOfferTransactionSuccessfullyStarted = false
                    state.isOfferTransactionSuccessfullyCompleted = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = true
                }
            })
    },
})
export const { displayInvoiceList, displaySingleInvoice,setIsTransactionSuccessfullyStarted,setIsTransactionSuccessfullyCompleted, resetAlbTelecomMobileSlice, displayMainUtilityView, changeConfirmationDialogState, setPhone, setSelectedOffer } = albtelecomMobileSlice.actions;

export const selectAlbtelecomMobileState = (state) => state.albtelecomMobile;

export default albtelecomMobileSlice.reducer;

